import type { RecognitionBulkImportResultDto, RecognitionBulkImportRowDto } from '@/api/recognition';
import type { BulkEditableRow } from './types';

/** Construye el payload que espera el backend a partir de las filas editables en pantalla. */
export function toRequestRows(rows: BulkEditableRow[]): RecognitionBulkImportRowDto[] {
  return rows.map((row) => ({
    emisorEmail: row.emisorEmail || null,
    receptorEmail: row.receptorEmail || null,
    fundamentalIds: row.fundamentalIds,
    mensaje: row.mensaje || null,
    externalId: row.externalId || null,
    emisorNomina: row.emisorNomina || null,
    receptorNomina: row.receptorNomina || null,
    behaviorIds: row.behaviorIds.length > 0 ? row.behaviorIds : null,
    habitIds: splitHabitIds(row.habitIds),
    lineNumber: row.lineNumber,
  }));
}

/** Divide "DH001; DH002 ;" en ["DH001","DH002"] — recorta espacios y descarta vacíos. Null si no
 *  queda ningún código, para que el backend distinga "no vino" de una lista vacía. */
function splitHabitIds(raw: string): string[] | null {
  const codes = raw.split(';').map((code) => code.trim()).filter((code) => code.length > 0);
  return codes.length > 0 ? codes : null;
}

/**
 * Aplica el resultado de un preview/confirmación a las filas en pantalla: una fila sin error
 * reportado para su `lineNumber` queda `valid`; una fila con error queda `invalid` con el código y
 * mensaje reales del backend (nunca inventados en el cliente).
 */
export function applyValidationResult(
  rows: BulkEditableRow[],
  result: RecognitionBulkImportResultDto,
): BulkEditableRow[] {
  const errorsByLine = new Map(result.rowErrors.map((rowError) => [rowError.lineNumber, rowError]));
  return rows.map((row) => {
    const rowError = errorsByLine.get(row.lineNumber);
    if (rowError) {
      return { ...row, status: 'invalid' as const, errorCode: rowError.code, errorMessage: rowError.message };
    }
    return { ...row, status: 'valid' as const, errorCode: null, errorMessage: null };
  });
}
